import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const request = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['token'] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code === 200 || res.code === 1) {
      return res;
    } else if (res.code === 0 || res.code === 408) {
      // 登录已过期，清除 token 并跳转到登录页
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      if (window.location.pathname !== '/h5/login') {
        window.location.href = '/h5/login';
      }
      return Promise.reject(new Error(res.msg || '登录已过期'));
    } else {
      return Promise.reject(new Error(res.msg || '请求失败'));
    }
  },
  error => {
    return Promise.reject(error);
  }
);

export default {
  get(url, params) {
    return request.get(url, { params });
  },
  post(url, data) {
    return request.post(url, data);
  },
  put(url, data) {
    return request.put(url, data);
  },
  delete(url, data) {
    return request.delete(url, { data });
  },
  upload(url, formData) {
    return request.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};